import api from '@/api'

const state = {
  goods: {} // 建品信息
}

const getters = {
  getTemperatureName: (state) => (id) => {
    switch (+id) {
      case 1: return '常温'
      case 2: return '冷藏'
      case 3: return '冷冻'
      case 4: return '恒温'
      case 5: return '保鲜'
      default: return ''
    }
  }
}

const mutations = {
  setGoods (state, data) {
    state.goods = Object.assign(state.goods, data)
  },
  resetGoods () {
    state.goods = {}
  }
}
const getPicArr = function (url, domain) {
  return url && url.length ? url.split('|').map(item => domain + item).join('|') : ''
}
const handleEditData = function (data) {
  var goods = {}
  goods.isShelfLife = +data.isShelfLife
  goods.expireDays = +data.expireDays
  goods.temperature = {id: +data.temperature}
  goods.oCountry = {id: +data.oCountry}
  goods.picsArr = getPicArr(data.pics, data.domainUrl)
  goods.loopPicsArr = getPicArr(data.loopPics, data.domainUrl)
  goods.packagePicsArr = getPicArr(data.packagePics, data.domainUrl)
  goods.detailPicsArr = getPicArr(data.detailPics, data.domainUrl)
  goods.lengthImgArr = getPicArr(data.lengthImg, data.domainUrl)
  goods.widthImgArr = getPicArr(data.widthImg, data.domainUrl)
  goods.heightImgArr = getPicArr(data.heightImg, data.domainUrl)
  goods.wholeWeightImgArr = getPicArr(data.wholeWeightImg, data.domainUrl)
  goods = Object.assign(data, goods)
  state.goods = goods
}
const actions = {
  getFormatGoods ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getAuditDetail(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          handleEditData(resData.data)
          resolve()
        } else {
          reject({from: '/sweb/goods/getAuditDetail', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getAuditDetail', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  delGoods ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.delGoods(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/delete', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/delete', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  newDelGoods ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.newDelGoods(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/supProduct/newDelete', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/supProduct/newDelete', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  submitProduct ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.submitProduct(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/submit', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/submit', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getGoodsDetail ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getProdDetail(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getDetail', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getDetail', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getNewGoodsDetail ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getNewProdDetail(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getNewDetail', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getNewDetail', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getProductList ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getProductList(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getProductList', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getProductList', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  checkProduct ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.checkProduct(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/checkProduct', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/checkProduct', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getPopClass1List ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getPopClass1List(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getPopClass1List', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getPopClass1List', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getClass1List ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getClass1List(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getClass1List', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getClass1List', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getClass1ListBySupplierId ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getClass1ListBySupplierId(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getClass1ListBySupplierId', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getClass1ListBySupplierId', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getClass2List ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getClass2List(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getClass2List', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getClass2List', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getClass3List ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getClass3List(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getClass3List', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getClass3List', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  queryCommonName ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.queryCommonName(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/queryCommonName', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/queryCommonName', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getOriginDict ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getOriginDict(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getOriginDict', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getOriginDict', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getTemplate ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getTemplate(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getTemplate', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getTemplate', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getAttrNameList ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getAttrNameList(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getAttrNameList', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getAttrNameList', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getMeasureDict ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getMeasureDict(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getMeasureDict', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getMeasureDict', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  checkIcode ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.checkIcode(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/supProduct/checkIcode', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/supProduct/checkIcode', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  queryAuditList ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.queryAuditList(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/queryNewAuditList', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/queryNewAuditList', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getAuditDetail ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getAuditDetail(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getAuditDetail', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getAuditDetail', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getNewAuditDetail ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getNewAuditDetail(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/getNewAuditDetail', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/getNewAuditDetail', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  auditEnumList ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.auditEnumList(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/goods/auditEnumList', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/goods/auditEnumList', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  storeProduct ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.storeGoods(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/supProduct/storage', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/supProduct/storage', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  listSupplierClass1 ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.listSupplierClass(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/public/listSupplierClass', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/public/listSupplierClass', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  queryBiName ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.queryBiName(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/supProduct/queryBiName', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/supProduct/queryBiName', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getArchiveTask ({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getArchiveTask(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/supProduct/getArchiveTask', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/supProduct/getArchiveTask', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  getNewAuditLog({commit, dispath}, data) {
    return new Promise((resolve, reject) => {
      api.getNewAuditLog(data).then(res => {
        const resData = res.data
        if (resData.ret === 1) {
          resolve(resData.data)
        } else {
          reject({from: '/sweb/supProduct/getNewAuditLog', error: resData.error.error})
        }
      }).catch(() => {
        reject({from: '/sweb/supProduct/getNewAuditLog', error: {code: 0, msg: '网络异常，请稍后重试'}})
      })
    })
  },
  listClass3ByClass2 ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getClass3List(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supProduct/getClass3List', error: resData.error.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supProduct/getClass3List', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  getPurchaseClass1List ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getPurchaseClass1List(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supProduct/getPurchaseClass1List', error: resData.error.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supProduct/getPurchaseClass1List', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  querySkuList ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.querySkuList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supProduct/querySkuList', error: resData.error.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supProduct/querySkuList', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  queryProductCreateSwitch ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.queryProductCreateSwitch(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData.data)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/supProduct/queryProductCreateSwitch', error: resData.error.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/supProduct/queryProductCreateSwitch', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/goods.js